module.exports = __webpack_public_path__ + "img/bottom3.5b054b55.png";